/**
 * Constants for TVI review components
 * Centralized location for shared constant values used across review components
 */

/**
 * Number of months in a year for plan calculations
 */
export const MONTHS_IN_YEAR = 12;

/**
 * SMS opt-in value for form submissions
 */
export const SMS_OPT_IN_VALUE = 'sms';

/**
 * Standard card width for review components
 */
export const CARD_WIDTH = '600px';
